import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-test-login',
  templateUrl: './test-login.component.html',
  styleUrls: ['./test-login.component.scss'],
  imports: [FormsModule, ReactiveFormsModule],
})
export class TestLoginComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  router = inject(Router);

  loginForm: FormGroup;
  isSubmitted = false;

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  controls() {
    return this.loginForm.controls;
  }

  submit() {
    this.isSubmitted = true;
    if (
      this.loginForm.get('email').value !== 'testuser' ||
      this.loginForm.get('password').value !== 'PointsAdmin-2021'
    ) {
      return;
    } else {
      localStorage.setItem('TestUsername', this.loginForm.get('email').value);
      localStorage.setItem('TestUserPassword', this.loginForm.get('password').value);
      this.router.navigate(['']);
    }
  }
}
